import {
  FETCH_EVENT_TICKETS_EXCEL_REQUEST,
  FETCH_EVENT_TICKETS_EXCEL_SUCCESS,
  FETCH_EVENT_TICKETS_EXCEL_FAILURE,
} from '../../../types/event';

const initialState = {
  loading: false,
  event: null,
  error: null,
  success: false,
};

const fetchEventTicketsExcelReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EVENT_TICKETS_EXCEL_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: null,
        success: false,
      });

    case FETCH_EVENT_TICKETS_EXCEL_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        event: action.payload,
        success: true,
      });

    case FETCH_EVENT_TICKETS_EXCEL_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
        success: false,
      });

    default:
      return state;
  }
};

export default fetchEventTicketsExcelReducer;
